<template>
  <div class="browse">
    <v-card flat="flat" class="nuclear">
      <v-card-title class="nuclear-title">
        <p>Enumeration / Browse All</p>
        <div class="control not_mobile">
          <div class="button_group">
            <v-btn
              :class="this.showTable ? 'table active' : 'table default'"
              @click="ShowTable"
            >
              <img
                src="/assets/images/table-active.svg"
                alt="Table Image"
                width="30px"
                height="26px"
                v-if="this.showTable == true"
              />
              <img
                src="/assets/images/table.svg"
                alt="Table Image"
                width="30px"
                height="26px"
                v-if="this.showTable == false"
              />
            </v-btn>
            <v-btn
              :class="this.showMap ? 'map active' : 'map default'"
              @click="ShowMap"
            >
              <img
                src="/assets/images/map-active.svg"
                alt="Map Image"
                width="21px"
                height="28px"
                v-if="this.showMap == true"
              />
              <img
                src="/assets/images/map.svg"
                alt="Map Image"
                width="21px"
                height="28px"
                v-if="this.showMap == false"
              />
            </v-btn>
          </div>
          <div class="search_part">
            <font-awesome-icon class="search_icon" icon="search" />
            <input
              id="search"
              type="text"
              placeholder="Search Description"
              v-model="search"
              @input="this.onSearchInput"              
            />
          </div>
        </div>
        <div class="control mobile">
          <div class="search_part">
            <font-awesome-icon class="search_icon" icon="search" />
            <input
              type="text"
              placeholder="Search Description"
              v-model="search"
            />
          </div>
          <div class="button_group">
            <v-btn
              :class="this.showTable ? 'table active' : 'table default'"
              @click="ShowMap"
            >
              <img
                src="/assets/images/table-active.svg"
                alt="Table Image"
                width="30px"
                height="26px"
                v-if="this.showTable == true"
              />
              <img
                src="/assets/images/table.svg"
                alt="Table Image"
                width="30px"
                height="26px"
                v-if="this.showTable == false"
              />
            </v-btn>
            <v-btn
              :class="this.showMap ? 'map active' : 'map default'"
              @click="ShowMap"
            >
              <img
                src="/assets/images/map-active.svg"
                alt="Map Image"
                width="21px"
                height="28px"
                v-if="this.showMap == true"
              />
              <img
                src="/assets/images/map.svg"
                alt="Map Image"
                width="21px"
                height="28px"
                v-if="this.showMap == false"
              />
            </v-btn>
          </div>
        </div>
      </v-card-title>
      <v-card-text v-if="this.showTable == true">
        <v-data-table
          :headers="headers"
          :items="items"
          hide-default-footer
          :disable-pagination="true"
          :search="search"
          item-key="id"
        >
          <template v-slot:item.index="{ item }">
            <div class="not_mobile">
              <span>{{ item.index }}</span>
            </div>
            <div class="mobile">
              <div>
                <span>{{ item.index }}</span>
                <span>{{ item.description }}</span>
              </div>
              <span>{{ item.vendor }}</span>
            </div>
          </template>
          <template v-slot:item.ipaddress="{ item }">
            <div class="not_mobile">
              <span>{{ item.ipaddress }}</span>
            </div>
            <div class="mobile">
              <span>{{ item.ipaddress }}</span>
              <div>
                <p>{{ item.city }}</p>
                <p>{{ item.country }}</p>
              </div>
            </div>
          </template>
        </v-data-table>
        <div class="text-center pt-2">
          <paginate
            :page-count="pageCount"
            :click-handler="checkPage"
            :prev-text="'Prev'"
            :next-text="'Next'"
            :container-class="'pagination'"
          >
          </paginate>
        </div>
      </v-card-text>
      <v-card-text v-if="this.showMap == true">
        <gmap-map :center="center" :zoom="11" style="width:100%;  height: 95vh">
          <gmap-marker
            :key="index"
            v-for="(m, index) in this.markers"
            :position="m.position"
            @click="center = m.position"
            :clickable="true"
            :draggable="true"
          ></gmap-marker>
        </gmap-map>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import Vue from "vue";
import Paginate from "vuejs-paginate";
Vue.component("paginate", Paginate);
export default {
  data() {
    return {
      headers: [
        { text: "No", align: "center", sortable: false, value: "index" },
        {
          text: "DESCRIPTION",
          align: "left",
          sortable: false,
          value: "description"
        },
        {
          text: "IP ADDRESS",
          align: "center",
          sortable: false,
          value: "ipaddress"
        },
        { text: "VENDOR", align: "center", sortable: false, value: "vendor" },
        { text: "CITY", align: "center", sortable: false, value: "city" },
        { text: "COUNTRY", align: "center", sortable: false, value: "country" }
      ],
      search: "",
      center: { lat: 34.052235, lng: -118.243683 },
      places: [],
      currentPlace: null,
      page: 1,
      limit: 20,
      pageCount: 0,

      showTable: true,
      showMap: false
    };
  },
  props: ["showmap", "showtable", "searchbuilding", "notificationId"],
  mounted() {
    this.geolocate();

    this.showTable = true;
    this.showMap = false;

    this.$store
      .dispatch("allBuilding", this.searchData())
      .then(response => {
        this.pageCount = response.data.total_pages;
      });
  },
  computed: {
    items() {
      return this.$store.state.enumeration.allbuildings;
    },
    markers() {
      return this.$store.state.enumeration.markers;
    }
  },
  methods: {
    ShowTable() {
      this.search = "";
      this.showTable = true;
      this.showMap = false;
    },
    ShowMap() {
      this.$store.dispatch("setMarkers", {});
      this.search = "";
      this.showMap = true;
      this.showTable = false;
    },
    setPlace(place) {
      this.currentPlace = place;
    },
    addMarker() {
      if (this.currentPlace) {
        const marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng()
        };
        this.markers.push({ position: marker });
        this.places.push(this.currentPlace);
        this.currentPlace = null;
      }
    },
    geolocate: function() {
      navigator.geolocation.getCurrentPosition(position => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
      });
    },
    checkPage(pageNum) {
      this.page = pageNum;
      this.$store.dispatch("allBuilding", this.searchData());
    },

    searchData() {
      if (this.searchbuilding != undefined && this.searchbuilding != '') {
        return {
          page: this.page,
          limit: this.limit,
          country: this.searchbuilding
        }
      }
      return {
        page: this.page,
        limit: this.limit
      }
    },

    onSearchInput() {
      if (!this.showMap) {
        return;
      }
      this.$store.dispatch("setMarkers", {
        search: this.search
      });
    }
  }
};
</script>
